// extracted by mini-css-extract-plugin
module.exports = {"profile_rounder":"style_profile_rounder__1T2oJ"};